<i class="icon"
   [ngClass]="wishlist.qty > 0 ? 'icon-wishlist-fill col-23' : 'icon-wishlist-thin'"
   aria-hidden="true"
   #iconRef></i>
<!-- add animation -->
<i class="icon icon-wishlist-fill will-animate col-23 ng-hide ng-hide-animate"
   aria-hidden="true"
   #iconHeartRef></i>